import hash from 'object-hash';
import useSWR from 'swr';
import { SWRCustomResponse } from '../../../hooks/types';
import { getSerpJobApplications, SerpJobApplicationProviderFilters } from '../../../providers/api/serp-job-applications/getSerpJobApplications';
import { PaginatedResult, PaginationParams } from '../../../providers/pagination';
import { SerpJobApplication } from '../../../providers/api/dtos';
import { useMatchMutate } from '../../../utils/swr/swr';

export const JOB_APPLICATIONS_SERP_RID = '/api/hr/v1/serp';

export function useSerpJobApplications(
  filters?: SerpJobApplicationProviderFilters,
  pagination: PaginationParams = { size: 20 },
): SWRCustomResponse<PaginatedResult<SerpJobApplication>, Error> {
  const matchMutate = useMatchMutate();
  const key = filters ? [JOB_APPLICATIONS_SERP_RID, hash({ ...filters, ...pagination })] : null;
  const result = useSWR(key, () => getSerpJobApplications(filters, pagination), {
    revalidateIfStale: true,
  });

  return {
    ...result,
    mutate: () => matchMutate(JOB_APPLICATIONS_SERP_RID),
  };
}
